import React from 'react';
import Timer from './components/Timer';
import styled from '@emotion/styled';
import { Analytics } from '@vercel/analytics/react';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #FFF5E6;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const Layout = styled.main`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 20px;
`;

function App() {
  return (
    <AppContainer>
      <Layout>
        <Timer />
      </Layout>
      <Analytics />
    </AppContainer>
  );
}

export default App; 